import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/components/Layout/Layout';
import Login from '@/pages/Login/Login';
import common from '@/assets/js/common.js';
import ErrorPage from '@/pages/Error/Error';
import CustomersPage from '@/pages/Accounts/Customers';
import ReportsPage from '@/pages/Accounts/Reports';
import ControlReportsPage from '@/pages/Accounts/ControlReports';
import UsersPage from '@/pages/Accounts/Users';
import DealsPage from '@/pages/Accounts/Deal';
import BrokerDealsPage from '@/pages/Accounts/BrokerDeal';
import CompanyPNLPage from '@/pages/Accounts/CompanyPNL';
import MarketValuePage from '@/pages/Accounts/MarketValue';
import FXRatePage from '@/pages/Accounts/FXRate';
import FDRatePage from '@/pages/Accounts/FDRate';
import TransactionsPage from '@/pages/Accounts/Transactions';
import SecurityPage from '@/pages/Accounts/Securities';
import mailServerPage from '@/components/Accounts/EmailServer';
import EventRegisterComponent from '@/components/Accounts/EventRegister';
// Core
import TypographyPage from '@/pages/Typography/Typography';

// Tables
import TablesBasicPage from '@/pages/Tables/Basic';

// Maps
import GoogleMapPage from '@/pages/Maps/Google';

// Main
import Dashboard from '@/pages/Dashboard/Dashboard_axcap';

// Charts
import ChartsPage from '@/pages/Charts/Charts';

// Ui
import IconsPage from '@/pages/Icons/Icons';
import NotificationsPage from '@/pages/Notifications/Notifications';


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (!window.localStorage.getItem('auth_token')) {
          next({
              path: '/login'
          })
        }else{
          common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('deal')?next({
                path: '/app/dashboard'
              }):next({name: Object.keys(result)[0]})
          })
        }
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/error',
      name: 'Error',
      component: ErrorPage,
    },
    {
      path: '/app',
      name: 'Layout',
      component: Layout,
      beforeEnter: (to, from, next) => {
        if (!window.localStorage.getItem('auth_token')) {
          next({
              path: '/login'
          })
        }else{
          common.methods.get_authorize().then(() => next())
        }
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
        },
        {
          path: 'users',
          name: 'user',
          component: UsersPage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('user')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'customers',
          name: 'customer',
          component: CustomersPage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('customer')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'client_reports',
          name: 'report',
          component: ReportsPage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('report')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'deals',
          name: 'deal',
          component: DealsPage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('deal')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'broker_deals',
          name: 'broker_deal',
          component: BrokerDealsPage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('broker_deal')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'company_pnl',
          name: 'company_pnl',
          component: CompanyPNLPage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('broker_deal')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'control_reports',
          name: 'control_report',
          component: ControlReportsPage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('report') ? next() : next({ name: Object.keys(result)[0] })
            })
          },
        },
        {
          path: 'marketvalues',
          name: 'marketvalue',
          component: MarketValuePage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('marketvalue')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'fxrates',
          name: 'fxrate',
          component: FXRatePage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('fxrate')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'fdrates',
          name: 'fdrate',
          component: FDRatePage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('fdrate')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'transactions',
          name: 'transaction',
          component: TransactionsPage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('transaction')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'stock',
          name: 'stock',
          component: SecurityPage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('stock')?next():next({name: Object.keys(result)[0]})
            })
          },
        },
        {
          path: 'email_server',
          name: 'mailServer',
          component: mailServerPage,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('email') ? next() : next({ name: Object.keys(result)[0] })
            })
          },
        },
        {
          path: 'event_register',
          name: 'eventRegister',
          component: EventRegisterComponent,
          beforeEnter: (to, from, next) => {
            common.methods.get_authorize().then((result) => {
              result.hasOwnProperty('event_register') ? next() : next({ name: Object.keys(result)[0] })
            })
          },
        },
        {
          path: 'typography',
          name: 'TypographyPage',
          component: TypographyPage,
        },
        {
          path: 'components/icons',
          name: 'IconsPage',
          component: IconsPage,
        },
        {
          path: 'notifications',
          name: 'NotificationsPage',
          component: NotificationsPage,
        },
        {
          path: 'components/charts',
          name: 'ChartsPage',
          component: ChartsPage,
        },
        {
          path: 'tables',
          name: 'TablesBasicPage',
          component: TablesBasicPage,
        },
        {
          path: 'components/maps',
          name: 'GoogleMapPage',
          component: GoogleMapPage,
        },
      ],
    },
  ],
});
